import { Button, Card, Container, Group, Image, SimpleGrid, Stack, Text, Title } from "@mantine/core";
import { IconBrandApple, IconBrandAndroid } from "@tabler/icons-react";

export const AppInformation = ({ withHeader = false }: {withHeader?: boolean}) => {
    return (
        <Container size="md" py={withHeader ? "md" : "xl"}>
            <Card withBorder radius="xl" p="xl" shadow="xs">
                <Stack gap="lg">
                    <div>
                        <Title order={withHeader ? 2 : 3}>Get Notifications</Title>
                        <Text c="var(--my-dark)" mt={4}>
                            Download the St. Mary & St. Mina mobile app to get notified when new appointments are available.
                        </Text>
                    </div>
                    <Group>
                        <Button
                            leftSection={<IconBrandApple size={20} />}
                            variant="light"
                            color="clinic"
                            onClick={() => window.open('https://apps.apple.com/us/app/st-mary-st-mina/id1508656131', '_blank')}
                        >
                            iOS / Apple Store
                        </Button>
                        <Button
                            leftSection={<IconBrandAndroid size={20} />}
                            variant="light"
                            color="accent"
                            onClick={() => window.open('https://play.google.com/store/apps/details?id=org.stmarystmina.application', '_blank')}
                        >
                            Android / Play Store
                        </Button>
                    </Group>
                    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
                        <Card withBorder radius="lg" padding="lg">
                            <Stack gap="sm">
                                <Text fw={600}>1. Open Settings after installing the app</Text>
                                <Image src="assets/get_notifications_for_clinic_1.png" alt="Settings" maw={220} />
                            </Stack>
                        </Card>
                        <Card withBorder radius="lg" padding="lg">
                            <Stack gap="sm">
                                <Text fw={600}>2. Enable St. Mina Clinic Messages</Text>
                                <Image src="assets/get_notifications_for_clinic_2.png" alt="Notifications" maw={220} />
                            </Stack>
                        </Card>
                    </SimpleGrid>
                </Stack>
            </Card>
        </Container>
    );
};
